<template>
  <div v-if="!nominee">Een moment geduld aub.</div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'QuickAdd',

  props: {
    categorySlug: {
      type: String,
      required: true,
    },

    nomineeSlug: {
      type: String,
      required: true,
    },
  },

  mounted() {
    const { nominee } = this

    if (nominee) {
      const { category } = nominee

      this.$store.dispatch('selectNominee', {
        categoryId: category.id,
        nomineeId: nominee.id,
      })

      this.$router.push({
        name: 'category',
        params: {
          categorySlug: category.slug,
        },
      })
    } else {
      this.$router.push({
        name: 'home',
      })
    }
  },

  computed: {
    ...mapState(['nominees']),

    nominee() {
      return this.nominees.find(
        (nominee) => nominee.slug === this.nomineeSlug && nominee.category.slug === this.categorySlug
      )
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/QuickAdd.vue